import { nameProperty } from "../property/static/name-property"
import { createDefaultPlannerColumn } from "./planner-column"

export const nameColumn = createDefaultPlannerColumn(
  nameProperty,
  "300px",
  "Event Name",
)
